export enum Mode {
  NORMAL, BLOCKLY, CODE, INPUTS, RESULT,
}
